export default __webpack_public_path__ + "static/media/kitchen4-afterC-1920w.112b457c.avif";